import { FormData } from "./types";

export const _defaultValues: FormData = {
  apiToken: "",
  email: "",
  projectID: "",
  issueTransitionID: "",
};
